import { render, staticRenderFns } from "./ModalPlanDetail.vue?vue&type=template&id=feea6ef8&"
import script from "./ModalPlanDetail.vue?vue&type=script&lang=js&"
export * from "./ModalPlanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports